global.$ = require('jquery');
global.jQuery = $;

require('jquery-ujs');
require('utils/snippets/input-masks');
require('utils/fullstory');
require('select2/select2');
require('select2/i18n/pt-BR');
require('utils/snippets/client');
require('utils/snippets/lytics');

global.jcep = require('jcep');


require('global_components');